<template>
  <div class="trade">
    <div class="head">
      <!-- <img @click="back" src="@/assets/images/back.png" class="arrow_img" /> -->
      <span>{{ tabList[tabIndex] }}</span>
    </div>
    <!-- 产品/服务器切换入口已取消，默认显示商城产品；服务器相关代码暂时保留 -->
    <div class="tab" v-if="false">
      <div class="tab_item" :class="tabIndex == index ? 'tab_active' : ''" v-for="(item, index) in tabList" :key="index" @click="changeTab1(index)">
        <span>{{ item }}</span>
      </div>
    </div>
    <!-- 产品 -->
    <template v-if="tabIndex == 0">
      <div class="title">
        <span>商城</span>
      </div>
      <div class="mall-layout">
        <aside class="mall-categories">
          <div class="mall-category" :class="{ active: selectedCategoryId === 0 }" @click="selectCategory(0)">全部</div>
          <div class="mall-category" v-for="item in categoryList" :key="item.id" :class="{ active: selectedCategoryId === item.id }" @click="selectCategory(item.id)">
            {{ item.name }}
          </div>
        </aside>
        <main class="mall-products">
          <div class="mall-section-title">{{ selectedCategoryName }}</div>
          <van-pull-refresh v-model="productRefreshing" @refresh="onProductRefresh">
            <div ref="productList">
              <div class="mall-grid">
                <div class="mall-card" v-for="(item, index) in displayProducts" :key="item.id || index" @click="goProductDetail(item)">
                  <div class="mall-image"><img :src="item.img_url" :alt="item.title" /></div>
                  <div class="mall-name">{{ item.title }}</div>
                  <div class="mall-price">$ {{ Number(item.price || 0).toFixed(2) }}</div>
                </div>
              </div>
              <div class="mall-loading" v-if="productLoading"><van-loading size="16px">加载中...</van-loading></div>
              <template v-if="!productLoading && displayProducts.length === 0">
                <div class="mall-empty">暂无商品</div>
              </template>
              <button class="mall-load-more" v-if="!productLoading && !productFinished" type="button" @click="onProductLoadMore">加载更多</button>
            </div>
          </van-pull-refresh>
        </main>
      </div>
      <div class="reserve" v-if="false">
        <div class="flex" style="margin: 0 0 12px">
          <div>
            <span>钱包额度: </span>
            <span class="text2">{{ walletBalance || 0 }} U</span>
          </div>
        </div>
        <div class="productItem" v-for="(item, index) in productsList" :key="index">
          <div class="flex1">
            <div class="service_img">
              <img :src="item.img_url" alt="" />
            </div>
            <div>
              <div style="margin: 12px 0">
                <span class="text1">{{ item.title }}</span>
              </div>
              <div style="margin: 12px 0">
                <span>价格 </span>
                <span class="text1">{{ Math.floor(item.price * 100) / 100 || 0 }} USDT</span>
              </div>
              <div style="margin: 12px 0">
                <span>赠送算力 </span>
                <span class="text1">{{ Math.floor(item.power * 100) / 100 || 0 }} T</span>
              </div>
            </div>
          </div>
          <div class="btn_box flex-end">
            <div :class="item.power == 0 ? 'btn2' : 'btn3'" @click="buyClick(item)">
              <span>{{ item.power == 0 ? '复购' : '立即购买' }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- 服务器购买 -->
    <template v-else>
      <div class="title">
        <span>服务器购买</span>
      </div>
      <div class="reserve">
        <div class="flex" style="margin: 0 0 12px">
          <div>
            <span>钱包额度: </span>
            <span class="text2">{{ walletBalance || 0 }} U</span>
          </div>
        </div>
        <div class="productItem" v-for="(item, index) in serversList" :key="index">
          <div class="flex1">
            <div class="service_img">
              <img src="@/assets/images/trade/introduce_img.png" alt="" />
            </div>
            <div>
              <div style="margin: 12px 0">
                <span class="text1">{{ item.title }}</span>
              </div>
              <div style="margin: 12px 0">
                <span>价格 </span>
                <span class="text1">{{ Math.floor(item.price * 100) / 100 || 0 }} USDT</span>
              </div>
              <div style="margin: 12px 0">
                <span>算力 </span>
                <span class="text1">{{ Math.floor(item.power * 100) / 100 || 0 }} T</span>
              </div>
            </div>
          </div>
          <div class="btn_box flex-end">
            <div class="btn3" @click="createOrder(item, 2)">
              <span>立即购买</span>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <span>购买记录</span>
      </div>
      <template v-if="showLoading">
        <div style="width: 100%">
          <van-loading style="margin-left: calc(50% - 10px)" />
        </div>
      </template>
      <template v-else-if="serversBuyRecord.length < 1">
        <div style="text-align: center; color: #000; padding-top: 16px">
          <span>暂无数据</span>
        </div>
      </template>
      <template v-else>
        <div class="today_reserve" v-for="(item, index) in serversBuyRecord" :key="index">
          <template v-if="item.order_type === 2">
            <div class="top flex">
              <span class="top_text1" style="padding-bottom: 6px">{{ item.order_no }}</span>
            </div>
            <div class="top flex">
              <span class="top_text1" style="color: #000">{{ item.pro_name }}</span>
              <span class="top_text2">{{ dateFormatFn(item.create_time) }}</span>
            </div>
          </template>
          <div class="top flex" v-else>
            <span class="top_text1">{{ item.pro_name }}</span>
            <span class="top_text2">{{ dateFormatFn(item.create_time) }}</span>
          </div>
          <div class="box_4"></div>
          <div class="flex" style="padding: 6px 0 6px">
            <div class="flex-col">
              <div style="padding-bottom: 12px">
                <span>支付金额</span>
                <span class="text3">{{ Math.floor(item.amount * 100) / 100 }} U</span>
              </div>
              <div>
                <span>算力</span>
                <span class="text3">{{ Math.floor(item.power * 100) / 100 }} T</span>
              </div>
            </div>
            <div class="flex-col" v-if="item.status === 0" @click="payOrder(item)">
              <div class="status status4">
                <span>{{ item.status_name }}</span>
              </div>
            </div>
            <div class="flex-col" v-else>
              <div class="status status1">
                <span>{{ item.status_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <ShippingAddressPopup :visible.sync="shippingAddressShow" :product="productDetail" @confirm="onShippingConfirm" />
    <!-- 加载弹窗 -->
    <van-popup v-model="isApprove" round style="width: 60%" :close-on-click-overlay="false">
      <div class="bind_box">
        <div style="font-weight: bold"><van-loading type="spinner" /></div>
        <div class="address_field">处理中...</div>
      </div>
    </van-popup>
    <BottomNavigation></BottomNavigation>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Web3 from 'web3';
import Clipboard from 'clipboard';
import BottomNavigation from '@/components/BottomNavigation.vue';
import ShippingAddressPopup from './ShippingAddressPopup.vue';
import { getErc20Contract } from '@/utils/contractHelp';
import { formatAmount } from '@/utils/format.js';
import { homeApi } from '@/api/index';
import { dateFormat } from '@/utils/formatTool.js';
import packApi from '@/methods/pack.js';
import { Toast } from 'vant';
import usdt from '@/methods/usdt.js';
export default {
  data() {
    return {
      tabList: ['产品', '服务器'],
      // tabList2: ['钱包余额', '系统余额', '报单算力余额'],
      tabIndex: 0,
      // tabIndex2: 0,
      images: [require('@/assets/images/trade/banner.png'), require('@/assets/images/trade/banner.png')],
      time: 0,
      walletBalance: 0, // 钱包余额
      payToken: undefined, //支付币种
      isApprove: false, // 控制加载弹窗显示隐藏
      serversList: [],
      productsList: [],
      categoryList: [],
      selectedCategoryId: 0,
      showLoading: true,
      serversBuyRecord: [],
      shippingAddressShow: false,
      // 提交订单时的收货信息（由 ShippingAddressPopup confirm 时回填）
      addressData: {
        real_name: '',
        mobile: '',
        address: '',
        area: '',
        province: '',
        city: '',
        district: '',
      },
      count: 0, //简单节流
      productDetail: {},
      // 产品分页状态
      productPage: 0,
      productPageSize: 10,
      productLoading: false,
      productRefreshing: false,
      productFinished: false,
      productRequestId: 0,
      unpagedProducts: null,
      lastProductScrollTop: 0,
    };
  },
  mounted() {
    this.init();
    window.addEventListener('scroll', this.onProductScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onProductScroll, true);
  },
  methods: {
    init() {
      if (this.account) {
        this.getProductsList();
        this.getCategoryList();
        this.serversInfo();
        if (this.tabIndex === 1) this.grtServersRecord();
        this.getPayToken(); //获取支付币种
      }
    },
    //返回上一页
    back() {
      this.$router.back();
    },
    changeTab1(index) {
      this.tabIndex = index;
      if (index === 1) this.grtServersRecord();
    },
    changeTab2(index) {
      this.tabIndex2 = index;
    },
    dateFormatFn(date) {
      return dateFormat(new Date(date * 1000), 'yyyy-MM-dd hh:mm:ss');
    },
    getPayToken() {
      packApi.getPayToken(this.account).then(res => {
        this.payToken = res;
        // this.handleApproveBtnShow(); //获取授权余额
        this.getWalletBalance(); //获取钱包余额
      });
    },
    // 查询链上钱包余额
    async getWalletBalance() {
      const erc20Contract = getErc20Contract(this.payToken);
      let bal = await erc20Contract.methods.balanceOf(this.account).call();
      this.walletBalance = (formatAmount(bal, 18) * 1).toFixed(2);
    },
    // 复制
    copy() {
      var clipboard = new Clipboard('.copys');
      clipboard.on('success', e => {
        this.$toast(this.$t('lang.swap222'));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on('error', e => {
        this.$toast(this.$t('lang.swap223'));
        clipboard.destroy(); // 释放内存
      });
    },

    getProductsList(isRefresh = false) {
      this.productPage = 1;
      this.productLoading = true;
      this.productRefreshing = isRefresh;
      this.productFinished = false;
      this.productsList = [];
      this.unpagedProducts = null;
      this.lastProductScrollTop = 0;
      this.productRequestId += 1;
      this.loadProducts(true);
    },
    loadProducts(reset = false) {
      if (this.unpagedProducts) {
        const end = this.productPage * this.productPageSize;
        this.productsList = this.unpagedProducts.slice(0, end);
        this.productFinished = end >= this.unpagedProducts.length;
        this.productLoading = false;
        return;
      }
      const requestId = this.productRequestId;
      const params = {
        page: this.productPage,
        page_size: this.productPageSize,
        category_id: this.selectedCategoryId || 0,
      };
      homeApi.productsList(params).then(res => {
        if (requestId !== this.productRequestId) return;
        this.productLoading = false;
        this.productRefreshing = false;
        if (res.code != 200) {
          this.productFinished = true;
          return;
        }
        let rows = res.data;
        const isPagedResponse = rows && !Array.isArray(rows) && Array.isArray(rows.rows);
        const total = isPagedResponse ? Number(rows.total) : 0;
        // 兼容未部署分页接口时返回的全量数组，仍按每页数量展示
        if (isPagedResponse) {
          rows = rows.rows;
        } else if (Array.isArray(rows)) {
          this.unpagedProducts = this.selectedCategoryId
            ? rows.filter(item => Number(item.category_id) === Number(this.selectedCategoryId))
            : rows;
          rows = this.unpagedProducts.slice(0, this.productPageSize);
        }
        if (!Array.isArray(rows)) rows = [];
        if (rows.length === 0) {
          this.productFinished = true;
          return;
        }
        if (reset) {
          this.productsList = rows;
        } else {
          this.productsList = this.productsList.concat(rows);
        }
        if (!isPagedResponse) {
          this.productFinished = this.productsList.length >= this.unpagedProducts.length;
        } else if (typeof res.data.has_more === 'boolean') {
          this.productFinished = !res.data.has_more;
        } else {
          this.productFinished = Number.isFinite(total)
            ? this.productsList.length >= total
            : rows.length < this.productPageSize;
        }
      }).catch(() => {
        if (requestId !== this.productRequestId) return;
        this.productLoading = false;
        this.productRefreshing = false;
        this.productFinished = true;
      });
    },
    onProductRefresh() {
      this.getProductsList(true);
    },
    onProductLoadMore() {
      if (this.productFinished || this.productLoading) return;
      this.productPage += 1;
      this.productLoading = true;
      this.loadProducts(false);
    },
    onProductScroll(event) {
      const list = this.$refs.productList;
      if (!list) return;
      const scroller = event.target === document ? document.scrollingElement : event.target;
      if (!scroller || (scroller !== document.scrollingElement && !scroller.contains(list))) return;
      const scrollTop = scroller.scrollTop;
      const scrollingDown = scrollTop > this.lastProductScrollTop;
      this.lastProductScrollTop = scrollTop;
      if (!scrollingDown || this.productLoading || this.productFinished || this.productRefreshing) return;
      const viewportBottom = scroller === document.scrollingElement
        ? window.innerHeight
        : scroller.getBoundingClientRect().bottom;
      if (list.getBoundingClientRect().bottom - viewportBottom <= 80) {
        this.onProductLoadMore();
      }
    },
    goProductDetail(item) {
      // 跳转到产品详情页（带基本参数，详情页支持按 id 重新拉取）
      try {
        const snapshot = encodeURIComponent(JSON.stringify(item));
        this.$router.push({
          name: 'productDetail',
          params: { id: String(item.id) },
          query: { snapshot },
        });
      } catch (e) {
        this.$router.push({ name: 'productDetail', params: { id: String(item.id) } });
      }
    },
    getCategoryList() {
      homeApi.categoryList().then(res => {
        if (res.code == 200) this.categoryList = (res.data || []).filter(item => !item.pid);
      });
    },
    selectCategory(id) {
      this.selectedCategoryId = id;
      // 切换分类时重置分页并重新拉取
      this.getProductsList();
    },
    serversInfo() {
      homeApi.serversInfo().then(res => {
        if (res.code == 200) {
          this.serversList = res.data.info;
        }
      });
    },
    cancel() {
      this.shippingAddressShow = false;
    },
    onShippingConfirm(payload) {
      // 收货信息弹层点击确认：保存 addressData、发起下单（仅产品 type=1）
      this.addressData = { ...payload.addressData };
      this.productDetail = payload.product || this.productDetail;
      this.shippingAddressShow = false;
      if (this.walletBalance * 1 < this.productDetail.price * 1) {
        this.$toast('余额不足');
        return;
      }
      this.count++;
      if (this.count == 1) {
        this.createOrder(this.productDetail, 1);
      }
    },
    buyClick(item) {
      // 老的入口：仍然兼容。跳到详情页
      this.goProductDetail(item);
    },
    grtServersRecord() {
      if (this.tabIndex !== 1) return;
      this.showLoading = true;
      homeApi.serversList({ order_type: 2 }).then(res => {
        if (res.code == 200) this.serversBuyRecord = res.data;
      }).catch(() => {
        this.serversBuyRecord = [];
      }).finally(() => {
        this.showLoading = false;
      });
    },
    // 下单
    createOrder(item, type) {
      // type:1产品 2服务器
      console.log(item);
      if (this.walletBalance * 1 < item.price * 1) {
        this.$toast('余额不足');
        return;
      }
      this.isApprove = true;
      let params = {};
      if (type == 1) {
        params = {
          ...this.addressData,
          id: item.id,
          type: type,
        };
      } else {
        params = {
          id: item.id,
          type: type,
        };
      }
      homeApi
        .createOrder(params)
        .then(res => {
          if (res.code == 200) {
            let obj = res.data;
            // 链上转账
            this.payMethod(obj, type);
            this.count = 0;
          } else {
            this.isApprove = false;
            this.$toast(res.msg);
            this.count = 0;
          }
        })
        .catch(err => {
          this.isApprove = false;
          this.count = 0;
        });
    },
    payOrder(item) {
      this.isApprove = true;
      homeApi.getOrder({ order_no: item.order_no, order_type: item.order_type }).then(res => {
        if (res.code != 200) {
          this.isApprove = false;
          this.$toast(res.msg);
          return;
        }
        if (res.data.amount > this.walletBalance * 1) {
          this.isApprove = false;
          this.$toast('余额不足');
          return;
        }
        this.payMethod(res.data, item.order_type);
      }).catch(err => {
        this.isApprove = false;
        this.$toast(err.msg);
      });
    },
    payMethod(obj, type) {
      usdt
        .transfer(this.account, obj.pay_address, obj.amount, this.payToken)
        .then(res => {
          console.log(res);
          // 调回调接口
          let params = {
            amount: obj.amount,
            type: type,
            order_no: obj.order_no,
            tx_hash: res,
          };
          homeApi
            .updateOrder(params)
            .then(res => {
              this.isApprove = false;
              if (res.code == 200) {
                Toast({ message: `${res.msg}` });
                this.grtServersRecord();
              }
            })
            .catch(err => {
              this.grtServersRecord();
              this.$toast(err.msg);
              this.isApprove = false;
              return;
            });
        })
        .catch(err => {
          console.log(11111111111);
          this.grtServersRecord();
          this.$toast(err.message);
          this.isApprove = false;
          return;
        });
    },
  },
  computed: {
    ...mapState(['account']),
    displayProducts() {
      if (!this.selectedCategoryId) return this.productsList;
      const categoryId = Number(this.selectedCategoryId);
      return this.productsList.filter(item => Number(item.category_id) === categoryId);
    },
    selectedCategoryName() {
      const category = this.categoryList.find(item => Number(item.id) === Number(this.selectedCategoryId));
      return category ? category.name : '全部商品';
    },
  },
  watch: {
    account() {
      this.init();
    },
  },
  components: {
    BottomNavigation,
    ShippingAddressPopup,
  },
};
</script>

<style lang="less" scoped>
.head {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(#000, 0.8);
  letter-spacing: 1.5px;
  font-weight: 550;
  background: #fff;
  padding: 14px 0;
  z-index: 99;
  .arrow_img {
    position: absolute;
    left: 20px;
    width: 10px;
    height: 16px;
  }
}
.trade {
  padding: 50px 16px 160px;
  min-height: 100vh;

  .tab {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin: 20px 0 0;
    background-color: #fff;
    border-radius: 40px;
    padding: 4px;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    &_item {
      text-align: center;
      color: #000;
      width: 50%;
    }
    &_active {
      color: #fff;
      font-weight: 700;
      padding: 10px 0;
      background-color: #7938cf;
      border-radius: 40px;
    }
    &_item1 {
      text-align: center;
      color: #000;
      width: 33%;
    }
    &_active1 {
      color: #fff;
      font-weight: 700;
      padding: 10px 0;
      background-color: #7938cf;
      border-radius: 40px;
    }
  }
  .banner {
    color: #fff;
    font-size: 22px;
    border-radius: 30px;
    // font-weight: bold;
    // background: url('~@/assets/image/banner.png') no-repeat top/100% 100%;
    // padding: 40px 0 0 20px;
    margin-top: 20px;
    .my-swipe {
      width: 100%;
      height: 155px;
      border-radius: 20px;
      box-sizing: border-box;
      .swipe-item {
        height: 100%;
        img {
          height: 155px;
        }
      }
    }
  }
  .countdown {
    font-size: 14px;
    font-weight: 600;
    padding: 16px;
    margin-top: 20px;
    background: url('~@/assets/images/index/countdown_bg.png') no-repeat top/100% 100%;

    .text {
      display: flex;
      justify-content: space-between;
      .text1 {
        color: rgba(#ffffff, 0.8);
        font-size: 12px;
        font-weight: normal;
      }
    }
    .time {
      padding-top: 10px;
      .colon {
        display: inline-block;
        margin: 0 4px;
        color: #fff;
      }
      .block {
        display: inline-block;
        // width: 22px;
        color: #7938cf;
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        padding: 2px 8px;
        border-radius: 3px;
        background-color: #ffffff;
      }
    }
  }
  .title {
    color: #7938cf;
    font-size: 15px;
    font-weight: 600;
    // font-style: italic;
    padding: 16px 0;
  }
  .mall-layout {
    display: flex;
    min-height: 470px;
    margin: 0 -16px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
  }
  .mall-categories {
    flex: 0 0 68px;
    background: #fafafa;
    border-right: 1px solid #f0f0f0;
  }
  .mall-category {
    position: relative;
    padding: 15px 4px;
    color: #999;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
  }
  .mall-category.active {
    color: #7938cf;
    font-weight: 600;
    background: #fff;
  }
  .mall-category.active::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    content: '';
    background: #7938cf;
  }
  .mall-products {
    flex: 1;
    min-width: 0;
    padding: 12px 10px 24px;
  }
  .mall-section-title {
    margin: 0 0 10px;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
  }
  .mall-section-title::before,
  .mall-section-title::after {
    display: inline-block;
    width: 38px;
    height: 1px;
    margin: 0 10px 4px;
    content: '';
    background: #bbb;
  }
  .mall-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  .mall-loading {
    padding: 16px 0;
    text-align: center;
  }
  .mall-load-more {
    display: block;
    margin: 16px auto 0;
    padding: 8px 20px;
    border: 0;
    border-radius: 16px;
    background: #f4edfb;
    color: #7938cf;
    font-size: 12px;
    cursor: pointer;
  }
  .mall-card {
    overflow: hidden;
    border: 1px solid #edf0ef;
    border-radius: 8px;
    background: #fff;
  }
  .mall-image {
    width: 100%;
    aspect-ratio: 1 / 1;
    padding: 6px;
    box-sizing: border-box;
  }
  .mall-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 6px;
  }
  .mall-name {
    overflow: hidden;
    padding: 0 8px 3px;
    color: #555;
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mall-price {
    padding: 0 8px 8px;
    color: #8ab89c;
    font-size: 12px;
  }
  .mall-empty {
    padding: 50px 0;
    color: #999;
    font-size: 13px;
    text-align: center;
  }
  .reserve {
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    letter-spacing: 0.8px;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    padding: 16px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 15px;

    .productItem {
      padding: 30px 0;
      border-bottom: 1px solid rgb(230, 233, 236);
    }
    .productItem:last-child {
      border-bottom: 0px solid rgb(230, 233, 236);
    }
    .text1 {
      color: rgba(34, 35, 64, 1);
      font-size: 16px;
      font-weight: 700;
    }
    .text2 {
      color: #7938cf;
      font-size: 16px;
      font-weight: 700;
    }

    .input_box {
      display: flex;
      align-items: center;
      margin: 12px 0;
      font-size: 14px;
      .input {
        color: #000;
        height: 36px;
        width: 250px;
        padding: 10px;
        border: none;
        border-radius: 8px;
        margin-right: 10px;
        background-color: rgba(236, 244, 245, 1);
      }
    }
    .btn_box {
      font-size: 14px;
      text-align: center;
      padding-top: 10px;
      justify-content: center;
      .btn1 {
        height: 40px;
        width: 90px;
        line-height: 40px;
        color: #7938cf;
        border-radius: 20px;
        background-color: rgba(232, 241, 253, 1);
      }
      .btn2 {
        height: 40px;
        width: 90px;
        line-height: 40px;
        color: #7938cf;
        border-radius: 20px;
        border: 1px solid #7938cf;
        background-color: #fff;
      }
      .btn3 {
        height: 40px;
        width: 90px;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        background-color: #7938cf;
        // margin-left: 20px;
      }
    }
  }
  .box_4 {
    background-color: rgb(224, 226, 228);
    width: 100%;
    box-sizing: border-box;
    height: 1px;
    margin: 20px 0 10px;
  }
  .today_reserve {
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    padding: 16px;
    box-shadow: 4px 4px 15px 0px rgba(180, 212, 212, 0.29);
    border-radius: 15px;
    margin-bottom: 15px;
    background-color: rgba(255, 255, 255, 0.3);
    .top_text1 {
      font-size: 15px;
      color: #7938cf;
    }
    .top_text2 {
      font-size: 12px;
      text-align: right;
      color: rgba(153, 153, 153, 1);
    }
    .text3 {
      color: #000;
      padding-left: 6px;
    }
    .status {
      padding: 6px 16px;
      font-size: 12px;
      border-radius: 30px;
    }
    .status1 {
      color: rgba(16, 209, 188, 1);
      background-color: rgba(224, 242, 240, 1);
    }
    .status4 {
      color: rgba(216, 176, 24, 1);
      background-color: rgba(247, 243, 228, 1);
    }
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex1 {
    display: flex;
    align-items: center;
    .service_img {
      padding-right: 16px;
      img {
        width: 100px;
        height: 90px;
        border-radius: 16px;
      }
    }
  }
  .flex-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex-end {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .flex-col {
    display: flex;
    // align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
}
.shippingAddress {
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;

  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    padding: 0 0 16px;
    border-bottom: 1px solid rgb(223, 239, 253);
  }

  .btn-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    .confirm {
      color: #fff;
      background: #7938cf;
    }
    .cancel {
      color: #7938cf;
      border: 1px solid #7938cf;
      background: #fff;
    }
  }
}
.area {
  width: 100%;
  height: 380px;
  padding: 16px;
  border-radius: 6px;
  background: #ffffff;
}

/deep/ .van-field {
  background-color: #f3f9fe;
  border-radius: 8px;
  margin: 6px 0;
}
/deep/ .van-field__body {
  padding: 10px 10px 10px 0;
}
/deep/.van-field__label {
  padding: 10px 0 10px 10px;
}
input::-webkit-input-placeholder {
  /* 使用webkit内核的浏览器 */
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input:-moz-placeholder {
  /* Firefox版本4-18 */
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input::-moz-placeholder {
  /* Firefox版本19+ */
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
input:-ms-input-placeholder {
  /* IE浏览器 */
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
}
.bind_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
  background-color: #000;
  .address_field {
    padding-top: 16px;
  }
}
</style>
